@if (isLoading) {
  <!-- Heart Loader -->
  <!-- Heart + EKG Loader -->
  <div class="loader-overlay" role="status" aria-live="polite">
    <div class="heart-wrapper" aria-hidden="true">
      <svg class="heart-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <!-- heart shape -->
        <path
          class="heart-shape"
          d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 6 4 4 6.5 4 8.24 4 9.91 5 10.54 6.36
               11.17 5 12.76 4 14.5 4 17 4 19 6 19 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
        />
        <!-- EKG line (white) -->
        <polyline class="ekg" points="3 12 7 12 9 8 11 15 13 6 15 12 21 12" fill="none" />
      </svg>
    </div>

    <p class="loader-text mt-3 fw-semibold text-dark">Loading...</p>
  </div>
}

@if (!isLoading) {
  <div class="container py-5">
    <h2 class="mb-4 text-center">Step 3: Doctor Verification</h2>

    <div class="row justify-content-center">
      <div class="col-md-8">
        <!-- Reactive Form -->
        <form [formGroup]="form" (ngSubmit)="onSubmit()" enctype="multipart/form-data">
          <!-- Medical Certificate Upload -->
          <div class="card mb-4 shadow-sm">
            <div class="card-body">
              <h5 class="card-title mb-3">
                <i class="bi bi-file-earmark-text text-primary me-2"></i>
                Upload Medical Certificate
              </h5>
              <div class="mb-3">
                <input
                  id="certificateFile"
                  class="form-control"
                  type="file"
                  (change)="onCertificateSelected($event)"
                />
                @if (certificateFile) {
                  <div class="mt-2 text-success small">
                    Selected: {{ certificateFile !== null ? certificateFile.name : '' }}
                  </div>
                }
                @if (form.get('certificate')?.touched && form.get('certificate')?.invalid) {
                  <div class="text-danger small mt-1">Certificate is required</div>
                }
              </div>
            </div>
          </div>

          <!-- Proof of Address Upload -->
          <div class="card mb-4 shadow-sm">
            <div class="card-body">
              <h5 class="card-title mb-3">
                <i class="bi bi-house text-success me-2"></i>
                Upload Proof of Address
              </h5>
              <div class="mb-3">
                <input
                  id="addressProofFile"
                  class="form-control"
                  type="file"
                  (change)="onAddressSelected($event)"
                />
                @if (addressFile) {
                  <div class="mt-2 text-success small">
                    Selected: {{ addressFile !== null ? addressFile.name : '' }}
                  </div>
                }
                @if (form.get('addressProof')?.touched && form.get('addressProof')?.invalid) {
                  <div class="text-danger small mt-1">Proof of address is required</div>
                }
              </div>
            </div>
          </div>

          <!-- Submit Button -->
          <div class="d-flex justify-content-end">
            <button type="submit" class="btn btn-primary px-4" [disabled]="form.invalid">
              Continue
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Bootstrap Icons -->
  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css"
  />
}
